// extracted by css-extract-rspack-plugin
export default {"cls1":"ErrorStateFeed-cls1_3MW","cls2":"ErrorStateFeed-cls2_vvg ErrorStateFeed-cls1_3MW"};